import { prop } from 'ramda';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useUserSelector } from 'js/store/hooks';
import { htcmdService } from 'js/services/htcmd.service';
import { useLoginByCredentials } from 'js/hooks/auth/hooks';
import { showCommonPopupAction } from 'js/components/common/popups/CommonPopup';

export const useBiometricsHandler = () => {
    const dispatch = useDispatch();
    const login = useLoginByCredentials();
    const loginName = useUserSelector(prop('loginName'));
    const password = useUserSelector(prop('password'));

    useEffect(() => {
        window.biometricsHandler = {
            biometricsAccepted: () => {
                htcmdService.enableBiometrics({
                    username: loginName,
                    pin: password
                });
            },
            biometricsEnabled: (isEnabled) => htcmdService.isBiometricsEnabled(isEnabled),
            processBiometricAuthentication: (isSuccessfulRecognition, pin, username) => {
                if (!isSuccessfulRecognition) {
                    return;
                }

                login(username, pin)
                    .catch((error) => {
                        const data = error?.data;

                        if (data?.errorCode) {
                            htcmdService.reset();

                            const spareMessage = data.errorText || data.errorMessage || data.playerMessage;
                            const getMessageFromActions = (actions) => {
                                const [{ message } = {}] = actions?.PlayerActionShowMessage || [];

                                return message;
                            };

                            dispatch(showCommonPopupAction({
                                title: 'playtech.mobile.system.login.error.biometricLogin',
                                content: getMessageFromActions(data.actions) || spareMessage,
                                layer: 'HIGH_PRIORITY'
                            }));
                        }
                    });
            }
        };
    }, [loginName, password, login, dispatch]);
};
